import { ProductContent } from '@printdeal/product-selector';
import { ITab } from '../types/product/productDetailPage';

export const getSizeTableTab = (productTabs?: ITab[]) => productTabs?.find((tab) => tab.type === 'size-table');

export const isValidNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value);

export const getProductVersion = (product?: ProductContent) =>
  (product?.isPimProduct && isValidNumber(product?.productVersion)
    ? product?.productVersion
    : undefined);
